import { Model } from 'es6/components/model'
import { Defaults } from 'es-decorators'

/**
 * Модель для прелоадера.
 */
@Defaults({
  defaults: {
    'isActivePreloader': false,
  },
})
export class Preloader extends Model {
  /**
   * @inheritDoc
   */
  sync () {
    return false
  }
}
